import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';

import {
  getQualification,
  updateEducationInfo,
  updateLocalTrainingInfo,
  updateForeignTrainingInfo,
  updatePublicationInfo,
  updateHonourInfo,
  updateRewardInfo,
  updateAdditionalProfessionalQualificationInfo,
  deleteEducationInfo,
  deleteLocalTrainingInfo,
  deleteForeignTrainingInfo,
  deleteAdditionalProfessionalQualificationInfo,
  deletePublicationInfo,
  deleteHonourInfo,
  deleteRewardInfo,
} from '@api/qualification';

import {
  QualificationActions,
  getQualificationFailed,
  getQualificationSuccess,
  updateEducationsInfoFailed,
  updateEducationsInfoSuccess,
  updateLocalTrainingsInfoFailed,
  updateLocalTrainingsInfoSuccess,
  updateForeignTrainingsInfoFailed,
  updateForeignTrainingsInfoSuccess,
  updateAdditionalProfessionalQualificationsInfoFailed,
  updateAdditionalProfessionalQualificationsInfoSuccess,
  updatePublicationsInfoFailed,
  updatePublicationsInfoSuccess,
  updateHonoursInfoFailed,
  updateHonoursInfoSuccess,
  updateRewardsInfoFailed,
  updateRewardsInfoSuccess,
  deleteEducationInfoFailed,
  deleteEducationInfoSuccess,
  deleteLocalTrainingInfoFailed,
  deleteLocalTrainingInfoSuccess,
  deleteForeignTrainingInfoFailed,
  deleteForeignTrainingInfoSuccess,
  deleteAdditionalProfessionalQualificationInfoFailed,
  deleteAdditionalProfessionalQualificationInfoSuccess,
  deletePublicationInfoFailed,
  deletePublicationInfoSuccess,
  deleteHonourInfoFailed,
  deleteHonourInfoSuccess,
  deleteRewardInfoFailed,
  deleteRewardInfoSuccess,
} from '@actions/HRM/employee/qualification-actions';
import {
  GET_QUALIFICATION,
  UPDATE_EDUCATION_INFO,
  UPDATE_LOCAL_TRAINING_INFO,
  UPDATE_FOREIGN_TRAINING_INFO,
  UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO,
  UPDATE_PUBLICATION_INFO,
  UPDATE_HONOUR_INFO,
  UPDATE_REWARD_INFO,
  DELETE_EDUCATION_INFO,
  DELETE_LOCAL_TRAINING_INFO,
  DELETE_FOREIGN_TRAINING_INFO,
  DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO,
  DELETE_PUBLICATION_INFO,
  DELETE_HONOUR_INFO,
  DELETE_REWARD_INFO,
} from '@actions/HRM/employee/types';

import { isRequestCancelled } from '@helpers/routing';
import { StoreType } from '@reducers/types';

export const qualificationMiddleware: Middleware<
  Record<string, unknown>,
  StoreType
> = ({ dispatch }: MiddlewareAPI) => {
  return (next: Dispatch<AnyAction>) => {
    return async (action: QualificationActions) => {
      const nextAction = next(action);
      switch (action.type) {
        case GET_QUALIFICATION.GET_QUALIFICATION_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await getQualification(payload);

            dispatch(getQualificationSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(getQualificationFailed());
            }
          }
          break;
        }

        case UPDATE_EDUCATION_INFO.UPDATE_EDUCATION_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateEducationInfo(payload);

            dispatch(updateEducationsInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateEducationsInfoFailed());
            }
          }

          break;
        }

        case UPDATE_LOCAL_TRAINING_INFO.UPDATE_LOCAL_TRAINING_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateLocalTrainingInfo(payload);

            dispatch(updateLocalTrainingsInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateLocalTrainingsInfoFailed());
            }
          }

          break;
        }

        case UPDATE_FOREIGN_TRAINING_INFO.UPDATE_FOREIGN_TRAINING_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateForeignTrainingInfo(payload);

            dispatch(updateForeignTrainingsInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateForeignTrainingsInfoFailed());
            }
          }

          break;
        }

        case UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } =
              await updateAdditionalProfessionalQualificationInfo(payload);

            dispatch(
              updateAdditionalProfessionalQualificationsInfoSuccess(data),
            );
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateAdditionalProfessionalQualificationsInfoFailed());
            }
          }

          break;
        }

        case UPDATE_PUBLICATION_INFO.UPDATE_PUBLICATION_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updatePublicationInfo(payload);

            dispatch(updatePublicationsInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updatePublicationsInfoFailed());
            }
          }

          break;
        }

        case UPDATE_HONOUR_INFO.UPDATE_HONOUR_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateHonourInfo(payload);

            dispatch(updateHonoursInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateHonoursInfoFailed());
            }
          }

          break;
        }

        case UPDATE_REWARD_INFO.UPDATE_REWARD_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateRewardInfo(payload);

            dispatch(updateRewardsInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateRewardsInfoFailed());
            }
          }

          break;
        }

        case DELETE_EDUCATION_INFO.DELETE_EDUCATION_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteEducationInfo(payload);

            dispatch(deleteEducationInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteEducationInfoFailed());
            }
          }

          break;
        }

        case DELETE_LOCAL_TRAINING_INFO.DELETE_LOCAL_TRAINING_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteLocalTrainingInfo(payload);

            dispatch(deleteLocalTrainingInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteLocalTrainingInfoFailed());
            }
          }

          break;
        }

        case DELETE_FOREIGN_TRAINING_INFO.DELETE_FOREIGN_TRAINING_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteForeignTrainingInfo(payload);

            dispatch(deleteForeignTrainingInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteForeignTrainingInfoFailed());
            }
          }

          break;
        }

        case DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } =
              await deleteAdditionalProfessionalQualificationInfo(payload);

            dispatch(
              deleteAdditionalProfessionalQualificationInfoSuccess(data),
            );
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteAdditionalProfessionalQualificationInfoFailed());
            }
          }

          break;
        }

        case DELETE_PUBLICATION_INFO.DELETE_PUBLICATION_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deletePublicationInfo(payload);

            dispatch(deletePublicationInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deletePublicationInfoFailed());
            }
          }

          break;
        }

        case DELETE_HONOUR_INFO.DELETE_HONOUR_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteHonourInfo(payload);

            dispatch(deleteHonourInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteHonourInfoFailed());
            }
          }

          break;
        }

        case DELETE_REWARD_INFO.DELETE_REWARD_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteRewardInfo(payload);

            dispatch(deleteRewardInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteRewardInfoFailed());
            }
          }

          break;
        }
      }
      return nextAction;
    };
  };
};
